import React from "react";
import { useState, useEffect } from "react";
import { getMultiIcon, urlDev, showUppertitle, showPreview } from "../../Config/Functions/Functions";
import axios from "axios";
const Ranking = () => {
    const [data, setData] = useState([])
    
    useEffect(() => {
        async function getData() {
            if (window) {
                let url = process.env.NEXT_PUBLIC_BASE_URL;
                try {
                    const res = await axios.get(`${url}/endpoints/news-list-ranking.json?publication=1&size=5&imagesizes=240x135;`);
                    setData(res?.data?.items);
                } catch (error) {
                    console.log(error)
                }
            }
        }
        getData()
    }, [])

    let count = 1
    return (
        <>  {
            data ?

                <section className="single-slider-section slider-section ranking-slider-section">
                    <header className="flex-container align-center has-mobile-gutter">
                        <div className="desktop-inner-container">
                            <h3 className="section-title font-700 uppercase">Lo más leído</h3>
                        </div>
                    </header>
                    <div className="fake-slider flex-container has-mobile-gutter">
                        {
                            data.map((dat, index) =>
                                <article className="fake-slider-entry-box" key={index}>
                                    <picture>
                                        {
                                            dat.preview ?
                                                <>
                                                    <img src={urlDev + dat?.preview?.sizes[0]?.url} width={240} height={135} alt={dat?.main?.title?.home} title={dat?.main?.title?.home} loading="lazy" />
                                                </>
                                                :
                                                <>
                                                    {showPreview(dat?.main?.title?.home, "240", "135")}
                                                </>
                                        }
                                        {/*getMultiIcon(dat?.hascontent?.hasgalleryvideosyoutube, dat?.gallery?.length > 1, dat?.hascontent?.hasaudios)*/}
                                        <div className="ranking-number-holder">
                                            <svg width="44.303" height="48" viewBox="0 0 44.303 48">
                                                <path d="M886.864,167.047A22.205,22.205,0,0,1,907.676,181.4a21.318,21.318,0,0,1-.74,16.666,21.858,21.858,0,0,1-12.492,11.273l-15.9,5.705,1-5.591-1.37-.573a21.665,21.665,0,0,1,1.128-40.515,22.4,22.4,0,0,1,7.565-1.32" transform="translate(-864.722 -167.047)" fill="#fb0d01" />
                                            </svg>
                                            <span className="ranking-number">{count++}</span>
                                        </div>
                                    </picture>
                                    <div className="entry-data">
                                        <h3 className="entry-title">{showUppertitle(dat?.main?.uppertitle)}{dat?.main?.title?.home}</h3>
                                    </div>
                                    <a href={dat?.info?.link?.url} className="cover-link" title={dat?.main?.title?.home}></a>
                                </article>
                            )
                        }
                    </div>
                </section> : null
        }
        </>
    )
}

export default Ranking;